module.exports = __webpack_public_path__ + "img/logo.e42be1fc.png";